import { PaymentMethodsPartialStoreState, PAYMENT_METHODS_STATE_KEY } from './payment-methods.reducer';

export const getAllPaymentMethods = (state: PaymentMethodsPartialStoreState) => state[PAYMENT_METHODS_STATE_KEY].all;

export const getSelectedPaymentMethod = (state: PaymentMethodsPartialStoreState) =>
    state[PAYMENT_METHODS_STATE_KEY].selected;

export const getPaymentMethodsLoading = (state: PaymentMethodsPartialStoreState) =>
    state[PAYMENT_METHODS_STATE_KEY].loading;

export const getPaymentError = (state: PaymentMethodsPartialStoreState) => state[PAYMENT_METHODS_STATE_KEY].error;

export const getAdyenSession = (state: PaymentMethodsPartialStoreState) =>
    state[PAYMENT_METHODS_STATE_KEY].adyenSession;

export const getCartRedirectUrl = (state: PaymentMethodsPartialStoreState) =>
    state[PAYMENT_METHODS_STATE_KEY].cartRedirectUrl;
